module.exports = __webpack_public_path__ + "static/media/linechart.dc215643.svg";